module.exports = __webpack_public_path__ + "img/62a2e27.png";